/** 已通过正式 Smartcat 创建或复用的 IP 文案 key；译文只由既有语言同步流程维护。 */
export const myIpCopyKeys = {
  media: {
    generateCard: 'RoboNeo_Web_ip_media_generateCard',
    settings: 'robo_basic_settings',
    more: 'robo_ip_more_assets',
    filter: 'RoboNeo_Web_ip_media_filter',
    all: 'all_voice',
    image: 'image_node',
    video: 'video_node',
    audio: 'audio_node',
    unknown: 'elements',
    preview: 'RoboNeo_Web_ip_media_preview',
    close: 'RoboNeo_Web_ip_media_close',
    enlargeMain: 'RoboNeo_Web_ip_media_enlargeMain',
    enlargeThreeView: 'RoboNeo_Web_ip_media_enlargeThreeView',
    unavailable: 'RoboNeo_Web_ip_media_unavailable',
    unsupported: 'RoboNeo_Web_ip_media_unsupported',
    empty: {
      all: 'RoboNeo_Web_ip_media_empty_all',
      image: 'RoboNeo_Web_ip_media_empty_image',
      video: 'RoboNeo_Web_ip_media_empty_video',
      audio: 'RoboNeo_Web_ip_media_empty_audio',
      unknown: 'RoboNeo_Web_ip_media_empty_all',
    },
  },
  roleCard: {
    view: 'view_ip_character_card',
    empty: 'there_is_no_ip_character_card',
  },
  shared: {
    loading: 'RoboNeo_Web_ip_shared_loading',
    retry: 'roboneo_web_retry',
    loadError: 'RoboNeo_Web_ip_shared_loadError',
    actionError: 'RoboNeo_Web_ip_shared_actionError',
    createWithIp: 'create_for_ta',
    coverUnavailable: 'RoboNeo_Web_ip_shared_coverUnavailable',
  },
  asset: {
    networkError: 'RoboNeo_Web_ip_asset_networkError',
    searchPersonal: 'RoboNeo_Web_ip_asset_searchPersonal',
    title: 'RoboNeo_Web_ip_asset_title',
    create: 'RoboNeo_Web_ip_asset_create',
    createDescription: 'RoboNeo_Web_ip_asset_createDescription',
    search: 'RoboNeo_Web_ip_asset_search',
    searchAction: 'search',
    noMatch: 'RoboNeo_Web_ip_asset_noMatch',
    empty: 'RoboNeo_Web_ip_asset_empty',
    detail: 'material_details',
    close: 'RoboNeo_Web_ip_asset_close',
    viewSettings: 'RoboNeo_Web_ip_asset_viewSettings',
    applyToCanvas: 'applied_to_canvas',
    loadMore: 'RoboNeo_Web_ip_asset_loadMore',
    loginRequired: 'RoboNeo_Web_ip_asset_loginRequired',
    creationUnavailable: 'RoboNeo_Web_ip_asset_creationUnavailable',
  },
  list: {
    title: 'RoboNeo_Web_ip_list_title',
    ipCount: 'RoboNeo_Web_ip_list_ipCount',
    cumulativeProjectCount: 'RoboNeo_Web_ip_list_cumulativeProjectCount',
    createTitle: 'RoboNeo_Web_ip_list_createTitle',
    createDescription: 'RoboNeo_Web_ip_list_createDescription',
    empty: 'Roboneo_web_no_data',
    loadMore: 'RoboNeo_Web_ip_asset_loadMore',
  },
  detail: {
    back: 'RoboNeo_Web_ip_detail_back',
    invalidIp: 'RoboNeo_Web_ip_detail_invalidIp',
    notFound: 'RoboNeo_Web_ip_detail_notFound',
    forbidden: 'RoboNeo_Web_ip_detail_forbidden',
    privateDescription: 'RoboNeo_Web_ip_detail_privateDescription',
    returnHome: 'roboneo_web_go_back_home',
    identity: 'RoboNeo_Web_ip_detail_identity',
    characterSettings: 'character_setting',
    visualAndAppearance: 'RoboNeo_Web_ip_detail_visualAndAppearance',
    threeViews: 'three_view_image',
    appearance: 'robo_character_appearance',
    visualStyle: 'RoboNeo_Web_ip_detail_visualStyle',
    personalityAndSetting: 'RoboNeo_Web_ip_detail_personalityAndSetting',
    personality: 'robo_character_traits',
    speechStyle: 'robo_character_speech_style',
    backstory: 'robo_character_story',
    relatedProjects: 'RoboNeo_Web_ip_detail_relatedProjects',
    noProjects: 'RoboNeo_Web_ip_detail_noProjects',
    loadMoreProjects: 'RoboNeo_Web_ip_detail_loadMoreProjects',
    playVoice: 'RoboNeo_Web_ip_detail_playVoice',
    pauseVoice: 'RoboNeo_Web_ip_detail_pauseVoice',
    mediaError: 'RoboNeo_Web_ip_detail_mediaError',
    voiceProgress: 'RoboNeo_Web_ip_detail_voiceProgress',
    persona: 'RoboNeo_Web_ip_detail_persona',
  },
  edit: {
    edit: 'RoboNeo_Web_ip_edit_edit',
    textOnly: 'RoboNeo_Web_ip_edit_textOnly',
    name: 'RoboNeo_Web_ip_edit_name',
    summary: 'RoboNeo_Web_ip_edit_summary',
    persona: 'RoboNeo_Web_ip_edit_persona',
    languageStyle: 'RoboNeo_Web_ip_edit_languageStyle',
    visualStyle: 'RoboNeo_Web_ip_detail_visualStyle',
    moreSettings: 'RoboNeo_Web_ip_edit_moreSettings',
    settingTitle: 'RoboNeo_Web_ip_edit_settingTitle',
    settingContent: 'RoboNeo_Web_ip_edit_settingContent',
    addSetting: 'RoboNeo_Web_ip_edit_addSetting',
    removeSetting: 'RoboNeo_Web_ip_edit_removeSetting',
    cancel: 'cancel_voice',
    save: 'save',
    saving: 'saving_',
    unsupported: 'RoboNeo_Web_ip_edit_unsupported',
    saveError: 'RoboNeo_Web_ip_edit_saveError',
    limits: {
      name: 'RoboNeo_Web_ip_edit_limits_name',
      summary: 'RoboNeo_Web_ip_edit_limits_summary',
      persona: 'RoboNeo_Web_ip_edit_limits_persona',
      languageStyle: 'RoboNeo_Web_ip_edit_limits_languageStyle',
      visualStyle: 'RoboNeo_Web_ip_edit_limits_visualStyle',
      moreSettings: 'RoboNeo_Web_ip_edit_limits_moreSettings',
      cover: 'RoboNeo_Web_ip_edit_limits_cover',
      profile: 'RoboNeo_Web_ip_edit_limits_profile',
    },
  },
} as const;
